document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('ContactForm');
  const full_name = document.getElementById('ContactForm-name');
  const email = document.getElementById('ContactForm-email');
  const subject = document.getElementById('ContactForm-subject');
  const body = document.getElementById('ContactForm-body');
  const fileInput = document.getElementById('ContactForm-file');
  const filePreview = document.getElementById('preview');
  const submitButton = document.querySelector('button[type="submit"]');

  let files = []
  const errorClass = 'error';

  const showError = (field, message) => {
    let errorElement = field.parentElement.querySelector('.error-message');

    if (!errorElement) {
      errorElement = document.createElement('span');
      errorElement.classList.add('error-message');
      field.parentElement.appendChild(errorElement);
    }

    errorElement.textContent = message;
    errorElement.style.display = 'block';
    field.classList.add(errorClass);
  };

  const clearError = (input) => {
    const errorElement = input.parentElement.querySelector('.error-message');
    if (errorElement) {
      errorElement.textContent = '';
      errorElement.style.display = 'none';
    }
    input.classList.remove(errorClass);
  };

  const validateField = (field, errorMessage) => {
    
    const value = field.value.trim();
    if (!value) {
      showError(field, errorMessage);
      return false;
    }
    clearError(field);
    return true;
  };

  fileInput.addEventListener('change', () => {
    const newFiles = Array.from(fileInput.files);
    files = [...files, ...newFiles.filter(newFile => !files.some(file => file.name === newFile.name))];
    renderFileList();
  });

  const handleRemoveFile = (index, event) => {
    files.splice(index, 1);
    const parent = event.target.closest('.file-item');
    if (parent) parent.remove();
  };

  const fileStatus = () => {
    const status = document.createElement('span');
    status.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <path d="M13.854 4.146a.5.5 0 0 1 0 .708l-7.5 7.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 0 1 .708-.708L6 11.293l7.146-7.147a.5.5 0 0 1 .708 0z"/>
      </svg> - Uploaded 100%
    `;

    return status;
  };

  const deleteButton = (index) => {
    const button = document.createElement('button');
    button.innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.3 5.70997C17.91 5.31997 17.28 5.31997 16.89 5.70997L12 10.59L7.11 5.69997C6.72 5.30997 6.09 5.30997 5.7 5.69997C5.31 6.08997 5.31 6.71997 5.7 7.10997L10.59 12L5.7 16.89C5.31 17.28 5.31 17.91 5.7 18.3C6.09 18.69 6.72 18.69 7.11 18.3L12 13.41L16.89 18.3C17.28 18.69 17.91 18.69 18.3 18.3C18.69 17.91 18.69 17.28 18.3 16.89L13.41 12L18.3 7.10997C18.68 6.72997 18.68 6.08997 18.3 5.70997Z" fill="#6A6A6A"></path>
      </svg>
    `;
    button.addEventListener('click', (event) => handleRemoveFile(index, event));
    
    return button;
  };

  const renderFileList = () => {
    filePreview.innerHTML = '';
    
    const fragment = document.createDocumentFragment();

    files.forEach((file, index) => {
      const fileItem = document.createElement('div');
      fileItem.classList.add('file-item');

      const fileName = document.createElement('p');
      fileName.textContent = file.name;
      
      fileItem.appendChild(fileName); 
      fileItem.appendChild(fileStatus());
      fileItem.appendChild(deleteButton(index));
      fragment.appendChild(fileItem);
    });

    filePreview.appendChild(fragment);
  }

  submitButton.addEventListener('click', (event) => {
    event.preventDefault()

    const fullNameValid = validateField(full_name, 'Name is required.');
    const emailValid = validateField(email, 'Email is required.');
    const subjectValid = validateField(subject, 'Subject is required.');
    const bodyValid = validateField(body, 'Message is required.');

    if (fullNameValid && emailValid && subjectValid && bodyValid) {
      // Crear un objeto FormData
      const formData = new FormData();
      
      // Agregar los campos del formulario al FormData
      formData.append('name', full_name.value);
      formData.append('email', email.value);
      formData.append('subject', subject.value);
      formData.append('message', body.value);

      // Agregar los archivos al FormData
      Array.from(fileInput.files).forEach(file => {
        formData.append('files[]', file);
      });

      // Enviar los datos al formulario de contacto de Shopify
      fetch('https://silverts-shop.myshopify.com/pages/contact#ContactForm', {
        method: 'POST',
        body: formData,
      })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          alert('Formulario enviado exitosamente');
        } else {
          alert('Hubo un error al enviar el formulario');
        }
      })
      .catch(error => {
        console.error('Error:', error);
        alert('Hubo un problema al enviar el formulario');
      });
    }
  });
});
